import axios from "axios";
import endPoints from "../../../../config/endPoints";


export const verifyReceiptApi = async(reqBody) => {
  return await axios.post(`${endPoints.receiptTracking}/find`, reqBody);
};

export const verifyOTPApi = async(reqBody) => {
  return await axios.post(`${endPoints.receiptManagement}/verification/validate-otp`, reqBody);
};

export const getOTPApi = async(reqBody) => {
  return await axios.post(`${endPoints.receiptManagement}/verification/get-otp`, reqBody);
};

export const renderServiceApi = async(provAgencyId, id, reqBody) => {
  return await axios.post(`${endPoints.receiptManagement}/service-use-update/${provAgencyId}/${id}`, reqBody);
};

export const getServiceRenderReport = async(reqBody) => {
  return await axios.post(`${endPoints.reports}/report`, reqBody);
};
